"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionTitle = void 0;
var section_title_component_1 = require("./section-title.component");
Object.defineProperty(exports, "SectionTitle", { enumerable: true, get: function () { return section_title_component_1.SectionTitle; } });
